
import React, { useEffect, useState } from 'react'
import { Card, List, Button, Input, Space, Modal, message } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { GeneralService } from '../../Services/GeneralService'
import { formatDate } from '../../components/Customs/dateFormatter'
import { notify } from '../../components/Customs/NotifyProvider'

import { canCreateModule, canUpdateModule, canDeleteModule } from '../../../utils/permissionUtils';

const MODULE_KEY = "manage_expense";

const ManageExpesecat = () => {
    const [amenities, setAmenities] = useState([])
    const [newAmenity, setNewAmenity] = useState('')
    const [search, setSearch] = useState('')
    const [editing, setEditing] = useState(null)
    const [editingValue, setEditingValue] = useState('')
    const [isModalOpen, setIsModalOpen] = useState(false)

    const loadAmenities = async () => {
        try {
            const response = await GeneralService.get('expense_categories')
            if (response.status) {
                setAmenities(response.data)
            } else {
                console.error('Failed to load Expenses Category: ' + response.message)
            }
        } catch (error) {
            console.error('Error loading Expenses Category: ' + error.message)
        }
    }

    useEffect(() => {
        loadAmenities()
    }, [])

    const persist = (next) => {
        setAmenities(next)
    }

    const handleAdd = () => {
        const value = newAmenity.trim()
        if (!value) {
            notify.warning('Enter an Expenses Category name to add')
            return
        }

        const payload = {
            name: value,
            created_at: formatDate(),
            updated_at: formatDate(),
        }

        console.log(payload);
        

        if (amenities.some(a => a.name === value)) {
            notify.warning('Expenses Category already added')
            return
        }

        const request = GeneralService.create('expense_categories',payload)
        request.then((response) => {
            if (response.status) {
                persist([...amenities, ...response.data])
                setNewAmenity('')
                notify.success('Expenses Category added')
            } else {
                notify.error('Failed to add Expenses Category: ', response.message)
            }
        }).catch((error) => {
            console.error('Error adding Expenses Category: ' + error.message)
            notify.error('Something went wrong while adding Expenses Category',error.message);
        })

       
    }

    const openEdit = (item) => {
        setEditing(item.id)
        setEditingValue(item.name)
        setIsModalOpen(true)
    }

    const handleEditSave = async () => {
        const value = editingValue.trim()
        if (!value) {
            notify.warning('Expenses Category cannot be empty')
            return
        }

        const payload = {
            name: value,
            updated_at: formatDate(),
        }

        try {
            const response = await GeneralService.update('expense_categories', editing, payload)
            if (response.status) {
                const updated = amenities.map((a) => (a.id === editing ? { ...a, name: value, updated_at: formatDate() } : a))
                persist(updated)
                setIsModalOpen(false)
                setEditing(null)
                setEditingValue('')
                notify.success('Expenses Category updated')
            } else {
                notify.error('Failed to update Expenses Category: ' + response.message)
            }
        } catch (error) {
            console.error('Error updating Expenses Category: ' + error.message)
            notify.error('Something went wrong while updating Expenses Category')
        }
    }

    const handleDelete = async (item) => {
        try {
            const response = await GeneralService.delete('expense_categories',item.id)
            if (response.status) {
                const next = amenities.filter((a) => a.id !== item.id)
                persist(next)
                notify.success('Expenses Category deleted')
            } else {
                notify.error('Failed to delete Expenses Category: ' + response.message)
            }
        } catch (error) {
            console.error('Error deleting Expenses Category: ' + error.message)
            notify.error('Something went wrong while deleting Expenses Category')
        }
    }

    return (
        <Card title="Expenses Category" 
            extra={
                <Input
                    size='large'
                    placeholder="Search Expenses Category"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ width: 320 }}
                    allowClear
                />
            }
        >


            <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
                <Input
                    size='large'
                    allowClear
                    placeholder="Add Expenses Category (e.g., Electricitiy, Cabs)"
                    value={newAmenity}
                    onChange={(e) => setNewAmenity(e.target.value)}
                    onPressEnter={handleAdd}
                    style={{ width: 420 }}
                />
            {canCreateModule(MODULE_KEY) && (
    <Button size='large' type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
        Add
    </Button>
)}
            </Space>

            <List
                bordered
                dataSource={amenities.filter((item) =>
                    item.name.toLowerCase().includes(search.trim().toLowerCase())
                )}
                locale={{ emptyText: 'No Expenses Category found!' }}
                renderItem={(item) => (
          <List.Item
    actions={[
        canUpdateModule(MODULE_KEY) && (
            <Button
                key="edit"
                type="text"
                icon={<EditOutlined />}
                onClick={() => openEdit(item)}
            />
        ),
        canDeleteModule(MODULE_KEY) && (
            <Button
                key="delete"
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(item)}
            />
        ),
    ].filter(Boolean)}
>
    {item.name}
</List.Item>
                )}
            />

            <Modal
                title="Edit Expenses Category"
                open={isModalOpen}
                onOk={handleEditSave}
                onCancel={() => setIsModalOpen(false)}
                okText="Save"
            >
                <Input
                    value={editingValue}
                    onChange={(e) => setEditingValue(e.target.value)}
                    onPressEnter={handleEditSave}
                />
            </Modal>
        </Card>
    )
}

export default ManageExpesecat
